import { criteria } from "./criteria";
import { review } from "./review";
import { schedule } from "./schedule";
import { statement } from "./statement";
import { codeName } from "./codeName";
import type { AutofillGroup, AutofillItem } from "./types";

/**
 * group ごとの定型文候補を静的に解決するレジストリ。
 * 文字列リテラルの import なので Vite が確実にバンドルでき、
 * 変数入り動的 import の解析制約を回避する。
 */
export const autofillData: Record<AutofillGroup, AutofillItem[]> = {
  criteria,
  review,
  schedule,
  statement,
  codeName,
};

export type { AutofillGroup, AutofillItem, AutofillContent } from "./types";
